import axios from "axios";
import {
    BASE_URL_API,
    LS_TOKEN_KEY,
    URL_API_ACTIVATE_USER,
    URL_API_APPOINTMENT_SET,
    URL_API_APPOINTMENTS,
    URL_API_CLIENT,
    URL_API_CLIENT_ADMIN,
    URL_API_CLIENT_ADMIN_ME,
    URL_API_COMPANY,
    URL_API_COMPANY_ME,
    URL_API_COMPANY_USERNAME,
    URL_API_CONSUMER_USER,
    URL_API_CONSUMER_USER_ME, URL_API_LOCATIONS,
    URL_API_ORDERS,
    URL_API_PAYOUTS,
    URL_API_RATES,
    URL_API_RELATIVE_APPOINTMENT,
    URL_API_RELATIVE_APPOINTMENT_SET,
    URL_API_RELATIVE_CANCEL,
    URL_API_RELATIVE_CATEGORY,
    URL_API_RELATIVE_CLIENTS,
    URL_API_RELATIVE_GET_JOIN_URL,
    URL_API_RELATIVE_NO_SHOW,
    URL_API_RELATIVE_RESERVATION,
    URL_API_RELATIVE_SHOW,
    URL_API_RELATIVE_SUBSCRIPTION,
    URL_API_RELATIVE_SUBSCRIPTION_VALID,
    URL_API_RELATIVE_TRANSACTIONS,
    URL_API_RELATIVE_UPLOAD,
    URL_API_RELATIVE_UPLOAD_COMPLETE,
    URL_API_RELATIVE_VIDEO, URL_API_RELATIVE_VIDEO_ARCHIVE,
    URL_API_RESERVATION,
    URL_API_SHOWCASES,
    URL_API_SUBSCRIPTIONS_TYPE,
    URL_API_USER_LOGIN,
    URL_API_VIDEOS, URL_STATEMENT
} from "../common/constants";
import {Utils} from "../common/utils";
import {
    URL_API_CONSUMER_RELATIVE_CHECKOUT, URL_API_CONSUMER_SHOWCASES,
    URL_API_RELATIVE_ACTIVE_SUBSCRIPTIONS,
    URL_API_RELATIVE_ORDER
} from "@/common/constants";
import {StorageHelper} from "../common/storageHelper";

const client = axios.create({
  baseURL: BASE_URL_API,
  responseType: "json"
});

function generateAuthorizationHeader() {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem(LS_TOKEN_KEY)
    }
  };
}

function generateAuthorizationConsumerHeader() {
    return {
        headers: {
            Authorization: "Bearer " + StorageHelper.getTokenConsumer()
        }
    };
}


export const doLoginUser = (username, password) => {
  const params = {
    username,
    password
  };
  return client
    .post(URL_API_USER_LOGIN, params)
    .then(res => {
      console.log("Login success", res.data);
      return res.data;
    })
    .catch(err => {
      console.error(err);
      throw err;
    });
};

export const getClientAdminInfo = () => {
  return client
    .get(URL_API_CLIENT_ADMIN_ME, generateAuthorizationHeader())
    .then(res => {
      console.log(res);
      return res.data;
    })
    .catch(err => {
      console.error(err);
      throw err;
    });
};

export const getCompanyInfo = () => {
    return client
        .get(URL_API_COMPANY_ME, generateAuthorizationHeader())
        .then(res => {
            console.log(res);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getClients = (page, limit) => {
  return client
      .get(Utils.composeUrlWithLimitAndOffset(URL_API_CLIENT, page, limit), generateAuthorizationHeader())
      .then(res => {
        console.log(res.data);
        return res.data;
      })
      .catch(err => {
        console.error(err);
        throw err;
      });
};

export const getClientDetail = (id) => {
    return client
        .get(URL_API_CLIENT + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const createClient = (first_name, last_name, phone_number, email) => {
    const data = {
        first_name,
        last_name,
        email,
        phone_number
    };
    return client
        .post(URL_API_CLIENT, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getRates = (page) => {
    return client
        .get(Utils.composeUrlWithLimitAndOffset(URL_API_RATES, page), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};



export const getAllRates = (arrayFilteredType=[]) => {
    let url = Utils.composeUrlWithInfiniteLimit(URL_API_RATES);
    if (arrayFilteredType.length !== 0) {
        for (let i = 0; i < arrayFilteredType.length; i++) {
            url += "&type=" + arrayFilteredType[i];
        }
    }
    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};



export const getAllClientAdmin = () => {
    return client
        .get(Utils.composeUrlWithInfiniteLimit(URL_API_CLIENT_ADMIN), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getAllClients = () => {
    return client
        .get(Utils.composeUrlWithInfiniteLimit(URL_API_CLIENT), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};




export const getRateDetail = (id) => {
    return client
        .get(URL_API_RATES + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};



export const createRate = (type, name, duration_in_minutes, max_participant, max_participant_online, price, price_online, appointment_count, valid_for_subscription_types) => {

    if (!price_online) {
        price_online = price
    }

    if (!max_participant_online) {
        max_participant_online = max_participant
    }

    const data = {
        name,
        type,
        duration_in_minutes,
        max_participant,
        max_participant_online,
        price,
        price_online,
        appointment_count,
        valid_for_subscription_types
    };
    return client
        .post(URL_API_RATES, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateRate = (id, type, name, duration_in_minutes, max_participant, max_participant_online, price, price_online, appointment_count) => {
    if (!price_online) {
        price_online = price
    }

    const data = {
        name,
        type,
        duration_in_minutes,
        max_participant,
        max_participant_online,
        price,
        price_online,
        appointment_count
    };
    return client
        .put(URL_API_RATES + id, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const deleteRate = (id) => {
    return client
        .delete(URL_API_RATES + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const deleteAppointmentSet = (id) => {
    return client
        .delete(URL_API_APPOINTMENT_SET + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};



export const getSubscriptionsType = (page) => {
    return client
        .get(Utils.composeUrlWithLimitAndOffset(URL_API_SUBSCRIPTIONS_TYPE, page), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getAllSubscriptionsType = () => {
    return client
        .get(Utils.composeUrlWithInfiniteLimit(URL_API_SUBSCRIPTIONS_TYPE), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};





export const createSubscriptionType = (name, category, price, unlimited_renewable, months_renewable, unlimited_redeemable, appointments_redeemable, valid_for_days, valid_for_rates = []) => {
    const data = {
        name,
        category,
        price,
        unlimited_renewable,
        months_renewable,
        unlimited_redeemable,
        appointments_redeemable,
        valid_for_rates,
        valid_for_days
    };
    return client
        .post(URL_API_SUBSCRIPTIONS_TYPE, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getSubscriptionTypeDetail = (id) => {
    return client
        .get(URL_API_SUBSCRIPTIONS_TYPE + '/' + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getSubscriptionsActive = (page, subscription_type_id) => {
    return client
        .get( Utils.composeUrlWithLimitAndOffset(URL_API_SUBSCRIPTIONS_TYPE + '/' + subscription_type_id + '/' + URL_API_RELATIVE_ACTIVE_SUBSCRIPTIONS, page), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const deleteSubscriptionType = (id) => {
    return client
        .delete(URL_API_SUBSCRIPTIONS_TYPE + '/' + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateSubscriptionTypeWithoutValidRates = (id, name, category, price, unlimited_renewable, months_renewable, unlimited_redeemable, appointments_redeemable, valid_for_days) => {
    const data = {
        name,
        category,
        price,
        unlimited_renewable,
        months_renewable,
        unlimited_redeemable,
        appointments_redeemable,
        valid_for_days
    };
    return client
        .put(URL_API_SUBSCRIPTIONS_TYPE + '/' + id, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const patchSubscriptionTypeValidRates = (id, valid_for_rates) => {
    const data = {
        valid_for_rates
    };
    return client
        .patch(URL_API_SUBSCRIPTIONS_TYPE + '/' + id, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const createAppointment = (rate_id, date, client_admin, is_online, repeat, repeat_day_of_week, repeat_until_date, location, notify=true) => {
    const data = {
        date,
        client_admin,
        is_online,
        repeat,
        repeat_day_of_week,
        repeat_until_date,
        location,
        notify
    };
    return client
        .post(URL_API_RATES + rate_id + "/" + URL_API_RELATIVE_APPOINTMENT, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const createMultipleAppointment = (rate_id, date, client_admin, is_online, location) => {
    const data = {
        date,
        client_admin,
        is_online,
        location
    };
    return client
        .post(URL_API_RATES + rate_id + "/" + URL_API_RELATIVE_APPOINTMENT_SET, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const updateAppointments = (appointments, set, is_online, location, notify) => {
    const data = {
        appointments,
        set,
        is_online,
        notify,
        location
    };

    return client
        .put(URL_API_APPOINTMENTS, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });

};

export const purchaseSubscription = (client_id, type, start_date, payment_mode, notify=true) => {
    const data = {
        type,
        start_date,
        payment_mode,
        notify
    };
    return client
        .post(URL_API_CLIENT + client_id + "/" + URL_API_RELATIVE_SUBSCRIPTION, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const createReservation = (client_id, rate, appointment_set, paid_by_subscription, payment_mode, notify=true) => {
    const data = {
        rate,
        appointment_set,
        paid_by_subscription,
        payment_mode,
        notify
    };
    return client
        .post(URL_API_CLIENT + client_id + "/" + URL_API_RELATIVE_RESERVATION, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getReservations = (page) => {
    return client
        .get(Utils.composeUrlWithLimitAndOffset(URL_API_RESERVATION, page), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getAppointments = (start_date, end_date) => {
    let url = URL_API_APPOINTMENTS;
    if (start_date && end_date) {
        url = Utils.composeUrlWithInfiniteLimit(URL_API_APPOINTMENTS);
        url += '&start_date=' + start_date + '&end_date=' + end_date
    }
    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getMyAppointmentsUntilToday = (page, filter) => {
    let url =  Utils.composeUrlWithLimitAndOffset(URL_API_APPOINTMENTS, page);
    let dateMidnight = new Date();
    dateMidnight.setHours(0,0,0,0);


    if(filter.date != null && filter.date !== ""){
        let dateEnd =  new Date(filter.date);
        let startDate =  new Date(filter.date);
        dateEnd.setHours(23,59,59,59);
        startDate.setHours(0,0,0,0);
        url += '&start_date=' + startDate.toISOString();
        url += '&end_date=' + dateEnd.toISOString();
    } else {
        url += '&end_date=' + dateMidnight.toISOString();
    }


    if(filter.rate != null){
        url += "&rate=" + filter.rate;
    }
    if(filter.admin != null){
        url += "&chaired_admin=" + filter.admin;
    }

    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getMyAppointmentsFromToday = (page,filter) => {
    let url = Utils.composeUrlWithLimitAndOffset(URL_API_APPOINTMENTS, page);

    let dateMidnight = new Date();
    dateMidnight.setHours(0,0,0,0);

    if(filter.date != null && filter.date !== ""){
        let dateEnd =  new Date(filter.date);
        let startDate =  new Date(filter.date);
        dateEnd.setHours(23,59,59,59);
        startDate.setHours(0,0,0,0);
        url += '&start_date=' + startDate.toISOString();
        url += '&end_date=' + dateEnd.toISOString();
    } else {
        url += '&start_date=' + dateMidnight.toISOString();

    }


    url += '&order_inverse=true';
    if(filter.rate != null){
        url += "&rate=" + filter.rate;
    }
    if(filter.admin != null){
        url += "&chaired_admin=" + filter.admin;
    }
    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getClientAppointments = (id) => {
    return client
        .get(URL_API_CLIENT + id + "/" + URL_API_RELATIVE_APPOINTMENT, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getClientReservations = (id) => {
    return client
        .get(URL_API_CLIENT + id + "/" + URL_API_RELATIVE_RESERVATION, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getClientSubscription = (id) => {
    return client
        .get(URL_API_CLIENT + id + "/" + URL_API_RELATIVE_SUBSCRIPTION, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getClientOrders = (id) => {
    return client
        .get(URL_API_CLIENT + id + "/" + URL_API_RELATIVE_ORDER, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const updateClient = (client_id, first_name, last_name, email, phone_number, acsi_card, note) => {
    const data = {
        client_id,
        first_name,
        last_name,
        email,
        phone_number,
        acsi_card,
        note
    };

    return client
        .put(URL_API_CLIENT + client_id , data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });

};

export const getClientValidSubscriptionForAppointmentSet = (client_id, appointment_set) => {
    return client
        .get(URL_API_CLIENT + client_id + "/"
            + URL_API_RELATIVE_SUBSCRIPTION_VALID
            + "?appointment_set_id="
            + appointment_set,
            generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getAppointmentDetail = (id) => {
    return client
        .get(URL_API_APPOINTMENTS + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getJoinMeetingUrl = (appointment_id, reservation_id) => {
    return client
        .get(URL_API_APPOINTMENTS + appointment_id + "/" + URL_API_RELATIVE_RESERVATION + "/" + reservation_id + "/"
            + URL_API_RELATIVE_GET_JOIN_URL, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const showClientAppointment = (client_id, appointment_id) => {
    return client
        .post(URL_API_CLIENT + client_id + "/" + URL_API_RELATIVE_APPOINTMENT + "/" + appointment_id + "/" + URL_API_RELATIVE_SHOW, null, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const noShowClientAppointment = (client_id, appointment_id) => {
    return client
        .post(URL_API_CLIENT + client_id + "/" + URL_API_RELATIVE_APPOINTMENT + "/" + appointment_id + "/" + URL_API_RELATIVE_NO_SHOW, null, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const cancelReservation = (reservation_id) => {
    return client
        .post(URL_API_RESERVATION + reservation_id + "/" + URL_API_RELATIVE_CANCEL, null, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const cancelAppointment = (appointment_id) => {
    return client
        .post(URL_API_APPOINTMENTS + appointment_id + "/" + URL_API_RELATIVE_CANCEL, null, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


// FOR CLIENTS WITHOUT PERMISSIONS


 export const getCompanyAppointments = (company_username, start_date, end_date, rates_filter=[]) => {
    let url = URL_API_COMPANY + company_username + "/" + URL_API_RELATIVE_APPOINTMENT;
    if (start_date && end_date) {
        url = Utils.composeUrlWithInfiniteLimit(url);
        url += '&start_date=' + start_date + '&end_date=' + end_date
    }

    if (rates_filter.length !== 0) {
        for (let i = 0; i < rates_filter.length; i++) {
            url += "&rate=" + rates_filter[i];
        }
    }

    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getPublicCompany = (company_username) => {
    let url = URL_API_COMPANY + company_username;
    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getClientAppointmentSetDetail = (company_username, appointment_set_id) => {
    let url = URL_API_COMPANY + company_username + "/" + URL_API_RELATIVE_APPOINTMENT_SET + "/" + appointment_set_id;

    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getClientCompanyByEmail = (company_username, email) => {
    let url = URL_API_COMPANY + company_username + "/" + URL_API_RELATIVE_CLIENTS + "/" + email;

    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getCompanyClientValidSubscriptionForAppointmentSet = (company_username, email, appointment_set) => {
    return client
        .get(URL_API_COMPANY + company_username + "/" + URL_API_RELATIVE_CLIENTS + "/" + email + "/"
            + URL_API_RELATIVE_SUBSCRIPTION_VALID
            + "?appointment_set_id="
            + appointment_set)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const createReservationClientPublic = (company_username, appointment_set, client_email, client_first_name, client_last_name,
                                              client_phone, paid_by_subscription, payment_mode, language) => {
    let url = URL_API_COMPANY + company_username + "/" + URL_API_RELATIVE_RESERVATION;
    const data = {
        appointment_set,
        client_email,
        client_first_name,
        client_last_name,
        client_phone,
        paid_by_subscription,
        payment_mode,
        language
    };
    return client
        .post(url, data)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getListSubscriptionTypeAvailablePublic = (company_username) => {
    let url = URL_API_COMPANY + company_username + "/" + URL_API_SUBSCRIPTIONS_TYPE;
    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const purchaseSubscriptionClientPublic = (company_username, client_email, client_first_name, client_last_name,
                                              client_phone, subscription_type, start_date, payment_mode, language) => {
    let url = URL_API_COMPANY + company_username + "/" + URL_API_RELATIVE_SUBSCRIPTION;
    const data = {
        subscription_type,
        client_email,
        client_first_name,
        client_last_name,
        client_phone,
        start_date,
        payment_mode,
        language
    };
    return client
        .post(url, data)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getOrders = (page, state=[]) => {
    let url = Utils.composeUrlWithLimitAndOffset(URL_API_ORDERS, page);

    if (state.length !== 0) {
        for (let i = 0; i < state.length; i++) {
            url += "&state=" + state[i];
        }
    }

    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getPayouts = (limit, starting_after=null) => {
    let url = URL_API_PAYOUTS + "?limit=" + limit;

    if (starting_after) {
        url += '&starting_after=' + starting_after;
    }


    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getPayoutDetail = (payout_id) => {
    let url = URL_API_PAYOUTS + payout_id;

    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getPayoutTransactions = (payout_id, limit, starting_after=null) => {
    let url = URL_API_PAYOUTS + payout_id + "/" + URL_API_RELATIVE_TRANSACTIONS + "?limit=" + limit;

    if (starting_after) {
        url += '&starting_after=' + starting_after;
    }


    return client
        .get(url, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getUsernameCompany = (id) => {
    return client
        .get(URL_API_COMPANY + id + "/" + URL_API_COMPANY_USERNAME, generateAuthorizationHeader())
        .then(res => {
            console.log(res);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getVideos = (page) => {
    return client
        .get(Utils.composeUrlWithLimitAndOffset(URL_API_VIDEOS, page), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getVideoDetail = (videoId) => {
    return client
        .get(URL_API_VIDEOS + videoId, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateVideo = (id, title, description, visibility, language) => {
    const data = {
        title,
        description,
        language,
        visibility
    };
    return client
        .put(URL_API_VIDEOS + id, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const deleteVideo = (id) => {
    return client
        .delete(URL_API_VIDEOS + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const archiveVideo = (id) => {
    return client
        .put(URL_API_VIDEOS + id + "/" + URL_API_RELATIVE_VIDEO_ARCHIVE, {}, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const createVideo = (title, description, language, video_id) => {

    const data = {
        title,
        description,
        language,
        video_id
    };
    return client
        .post(URL_API_VIDEOS, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getShowcases = (page) => {
    return client
        .get(Utils.composeUrlWithLimitAndOffset(URL_API_SHOWCASES, page), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getShowcaseDetail = (showcaseId) => {
    return client
        .get(URL_API_SHOWCASES + showcaseId, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateShowcase = (id, title, description, state,  privacy, password, price) => {
    const data = {
        title,
        description,
        privacy,
        state,
        password,
        price
    };
    return client
        .put(URL_API_SHOWCASES + id, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const deleteShowcase = (id) => {
    return client
        .delete(URL_API_SHOWCASES + id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const createShowcase = (title, description, state, privacy, password, price) => {

    const data = {
        title,
        description,
        state,
        privacy,
        password,
        price
    };
    return client
        .post(URL_API_SHOWCASES, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const deleteVideoFromShowcase = (showcase_id, video_id) => {
    return client
        .delete(URL_API_SHOWCASES + showcase_id +  "/" + URL_API_RELATIVE_VIDEO + "/" + video_id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const  patchVideosInShowcase = (id, videos) => {
    const data = {
        videos
    };
    return client
        .patch(URL_API_SHOWCASES + id, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getAllVideos = () => {
    return client
        .get(Utils.composeUrlWithInfiniteLimit(URL_API_VIDEOS), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getPublicShowcaseDetail = (showcaseFingerprint) => {
    let url = URL_API_SHOWCASES + showcaseFingerprint;
    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getPublicShowcaseDetailWithToken = (showcaseFingerprint) => {
    let url = URL_API_SHOWCASES + showcaseFingerprint;
    return client
        .get(url, generateAuthorizationConsumerHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getPublicShowcaseDetailWithPassword = (showcaseFingerprint, password) => {
    let url = URL_API_SHOWCASES + showcaseFingerprint + "?password=" + password;
    return client
        .get(url)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const createSeparator = (id_category, name) => {

    const data = {
        name,
    };
    return client
        .post(URL_API_SHOWCASES + id_category + "/" + URL_API_RELATIVE_CATEGORY, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const deleteSeparator = (id_showcase, id_category) => {
    return client
        .delete(URL_API_SHOWCASES + id_showcase + "/" + URL_API_RELATIVE_CATEGORY + "/" + id_category, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const updateSeparator = (id_showcase, id_category, name) => {
    const data = {
        name
    };
    return client
        .put(URL_API_SHOWCASES + id_showcase + "/" + URL_API_RELATIVE_CATEGORY + "/" + id_category, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateVideoShowcase = (id_showcase, data) => {
    const dataPost = {
        data
    };
    return client
        .put(URL_API_SHOWCASES + id_showcase + "/" + URL_API_RELATIVE_VIDEO, dataPost, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateLanguageUser = (language) => {

    const data = {
        language
    };
    return client
        .patch(URL_API_CONSUMER_USER_ME, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateDefaultCurrencyUser = (default_currency) => {

    const data = {
        default_currency
    };
    return client
        .patch(URL_API_CONSUMER_USER_ME, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const uploadVideo = (video_id, size) => {

    const data = {
        size
    };
    return client
        .post(URL_API_VIDEOS + video_id + "/" + URL_API_RELATIVE_UPLOAD, data, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const completeUploadVideo = (video_id) => {

    return client
        .post(URL_API_VIDEOS + video_id + "/" + URL_API_RELATIVE_UPLOAD + "/" + URL_API_RELATIVE_UPLOAD_COMPLETE, null, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getOrderDetail = (id) => {
    return client
        .get(URL_API_ORDERS+ id, generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

// CONSUMER API

export const createUser = (first_name, last_name, email, password, phone_number, timezone, language, country, default_currency) => {

    const data = {
        first_name,
        last_name,
        email,
        password,
        phone_number,
        timezone,
        language,
        country,
        default_currency
    };
    return client
        .post(URL_API_CONSUMER_USER, data)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const getUserInfo = () => {
    return client
        .get(URL_API_CONSUMER_USER_ME, generateAuthorizationConsumerHeader())
        .then(res => {
            console.log(res);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const purchaseShowcase = (showcase_fingerprint) => {
    return client
        .post(URL_API_CONSUMER_SHOWCASES + showcase_fingerprint + "/" + URL_API_CONSUMER_RELATIVE_CHECKOUT, null, generateAuthorizationConsumerHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const activateUser = (uidb64, token) => {
    return client
        .post(URL_API_ACTIVATE_USER + uidb64 + "/" + token + "/", null)
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const updateLanguageUserConsumer = (language) => {

    const data = {
        language
    };
    return client
        .patch(URL_API_CONSUMER_USER_ME, data, generateAuthorizationConsumerHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};

export const updateDefaultCurrencyUserConsumer = (default_currency) => {

    const data = {
        default_currency
    };
    return client
        .patch(URL_API_CONSUMER_USER_ME, data, generateAuthorizationConsumerHeader())
        .then(res => {
            console.log(res.data);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const  getAllLocation = () => {
    return client
        .get(Utils.composeUrlWithInfiniteLimit(URL_API_LOCATIONS), generateAuthorizationHeader())
        .then(res => {
            console.log(res.data);
            return res.data.results;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};


export const getStatement = (month=null, year=null) => {
    let urlStatement = URL_STATEMENT
    if (month != null && year != null) {
        urlStatement += `?month=${month+1}&year=${year}`
    }

    return client
        .get(urlStatement, generateAuthorizationHeader())
        .then(res => {
            console.log(res);
            return res.data;
        })
        .catch(err => {
            console.error(err);
            throw err;
        });
};
